// extracted by mini-css-extract-plugin
module.exports = {"container":"container--iiXIW","sider_logo":"sider_logo--Bt2_1","sider_menu":"sider_menu--1jyKL","content_wrapper":"content_wrapper--2APP-","header_wrapper":"header_wrapper--2cPgt"};